
(() => {
  if (window.leclairRewardsInitialized) return;
  window.leclairRewardsInitialized = true;

  const GOALS = [15000, 29900, 39900];
  const MAX = 39900;
  const ROOT = window.Shopify?.routes?.root || '/';

  let timer;
  let requestId = 0;

  function formatMoney(cents, currency = 'BRL') {
    try {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency
      }).format(cents / 100);
    } catch {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  function updateBar(el, total, currency = 'BRL') {
    if (!el || !el.isConnected) return;

    const amount = Math.max(0, Number(total) || 0);
    const progress = Math.min(100, (amount / MAX) * 100);

    const fill = el.querySelector('[data-lr-fill]');
    const message = el.querySelector('[data-lr-message]');

    if (fill) fill.style.width = progress + '%';

    el.querySelectorAll('[data-lr-goal]').forEach(node => {
      const goal = Number(node.dataset.lrGoal);
      node.classList.toggle('is-unlocked', amount >= goal);
    });

    el.querySelectorAll('[data-lr-item]').forEach(node => {
      const goal = Number(node.dataset.lrItem);
      node.classList.toggle('is-unlocked', amount >= goal);
    });

    if (!message) return;

    if (amount < GOALS[0]) {
      message.textContent =
        `Faltam ${formatMoney(GOALS[0] - amount, currency)} para ganhar seu primeiro brinde!`;
    } else if (amount < GOALS[1]) {
      message.textContent =
        `Brinde liberado! Faltam ${formatMoney(GOALS[1] - amount, currency)} para ganhar frete grátis.`;
    } else if (amount < GOALS[2]) {
      message.textContent =
        `Frete grátis liberado! Faltam ${formatMoney(GOALS[2] - amount, currency)} para ganhar uma calcinha.`;
    } else {
      message.textContent =
        'Você desbloqueou todas as recompensas!';
    }
  }

  async function refresh() {
    const elements = document.querySelectorAll('[data-leclair-rewards]');
    if (!elements.length) return;

    const currentId = ++requestId;

    try {
      const response = await fetch(ROOT + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) return;

      const cart = await response.json();
      if (currentId !== requestId) return;

      const total = cart.items_subtotal_price;
      const currency = cart.currency || 'BRL';

      document.querySelectorAll('[data-leclair-rewards]')
        .forEach(el => {
          el.dataset.total = total;
          updateBar(el, total, currency);
        });

    } catch (error) {
      console.warn('Erro ao atualizar recompensas:', error);
    }
  }

  function scheduleRefresh(delay = 120) {
    clearTimeout(timer);
    timer = setTimeout(refresh, delay);
  }

  // Inicializa os elementos renderizados pelo Liquid
  function initialize() {
    document.querySelectorAll('[data-leclair-rewards]')
      .forEach(el => {
        updateBar(el, Number(el.dataset.total) || 0);
      });

    scheduleRefresh();
  }

  // Acompanha atualizações nativas do tema Impact
  ['cart:change', 'cart:refresh', 'cart:updated', 'cart-drawer:updated']
    .forEach(name => {
      document.addEventListener(name, () => scheduleRefresh());
    });

  // Detecta atualizações completas do HTML do drawer
  const observer = new MutationObserver(records => {
    const changed = records.some(record => {
      return [...record.addedNodes, ...record.removedNodes]
        .some(node => {
          if (node.nodeType !== 1) return false;

          // Ignora alterações internas da própria barra
          if (node.closest?.('[data-leclair-rewards]') &&
              !node.matches?.('[data-leclair-rewards]')) {
            return false;
          }

          return Boolean(
            node.matches?.('[data-leclair-rewards], cart-drawer, .cart-drawer, .cart-drawer__content') ||
            node.querySelector?.('[data-leclair-rewards]')
          );
        });
    });

    if (changed) scheduleRefresh();
  });

  function startObserver() {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Acompanha alterações de quantidade e remoção de itens
  document.addEventListener('change', event => {
    if (event.target.closest('cart-drawer, .cart-drawer')) {
      scheduleRefresh(350);
    }
  });

  document.addEventListener('click', event => {
    if (event.target.closest('cart-drawer, .cart-drawer')) {
      scheduleRefresh(400);
    }
  });

  // Caso o tema utilize solicitações AJAX sem disparar eventos
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    const request = args[0];
    const url = typeof request === 'string'
      ? request
      : request?.url || '';

    const method = (
      args[1]?.method ||
      request?.method ||
      'GET'
    ).toUpperCase();

    const cartMutation =
      method !== 'GET' &&
      /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url);

    const result = originalFetch.apply(this, args);

    if (cartMutation) {
      result.then(response => {
        if (response.ok) scheduleRefresh(180);
      }).catch(() => {});
    }

    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      startObserver();
      initialize();
    });
  } else {
    startObserver();
    initialize();
  }
})();
